import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Mail, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = '/api';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/auth/login`, credentials);
      localStorage.setItem('admin_token', response.data.access_token);
      localStorage.setItem('admin_email', response.data.email);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid email or password');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 lg:p-12 border border-[#E5E5E5]"
      >
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles className="w-10 h-10 text-[#FF4500]" />
            <h1 className="text-3xl font-black text-[#0A0A0A] tracking-tight">MNA Consult</h1>
          </div>
          <h2 className="text-2xl font-bold tracking-tight mb-2">Admin Login</h2>
          <p className="text-[#525252]">Access your dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-[#0A0A0A] mb-2">
              Email Address
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#525252]" />
              <input
                id="email"
                type="email"
                required
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                className="w-full h-12 pl-12 pr-4 bg-[#F4F4F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4500] transition-all duration-300"
                placeholder="admin@mnaconsult.com"
                data-testid="admin-email-input"
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-[#0A0A0A] mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#525252]" />
              <input
                id="password"
                type="password"
                required
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="w-full h-12 pl-12 pr-4 bg-[#F4F4F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4500] transition-all duration-300"
                placeholder="Enter your password"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#FF4500] text-white h-12 rounded-lg hover:bg-[#E03E00] transition-all duration-300 font-semibold shadow-[0_8px_16px_rgba(255,69,0,0.3)] disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="admin-login-button"
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-sm text-[#525252] hover:text-[#FF4500] transition-colors duration-300">
            Back to Home
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;